import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cardExpiry',
  standalone: true,
})
export class CardExpiryPipe implements PipeTransform {
  transform(month: number | string, year: number | string) {
    const m = Number(month);
    const y = Number(year);

    return {
      month: m.toString().padStart(2, '0'),
      year: y,
    };
  }
}
